"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListItemResponseRulesToJSON = exports.TemplateGalleryListItemResponseRulesFromJSONTyped = exports.TemplateGalleryListItemResponseRulesFromJSON = exports.instanceOfTemplateGalleryListItemResponseRules = exports.TemplateGalleryListItemResponseRulesTriggerOperatorEnum = exports.attributeTypeMapTemplateGalleryListItemResponseRules = void 0;
var TemplateGalleryListItemResponseTriggerJoined_1 = require("./TemplateGalleryListItemResponseTriggerJoined");
var TemplateGalleryListItemResponseActionJoined_1 = require("./TemplateGalleryListItemResponseActionJoined");
exports.attributeTypeMapTemplateGalleryListItemResponseRules = [
    {
        name: "id",
        type: "string",
    },
    {
        name: "triggerOperator",
        type: "string",
    },
    {
        name: "triggers",
        type: "Array<TemplateGalleryListItemResponseTriggerJoined>",
    },
    {
        name: "actions",
        type: "Array<TemplateGalleryListItemResponseActionJoined>",
    },
];
/**
 * @export
 */
exports.TemplateGalleryListItemResponseRulesTriggerOperatorEnum = {
    And: "AND",
    Or: "OR",
};
/**
 * Check if a given object implements the TemplateGalleryListItemResponseRules interface.
 */
function instanceOfTemplateGalleryListItemResponseRules(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("triggerOperator" in value) || value["triggerOperator"] === undefined)
        return false;
    if (!("triggers" in value) || value["triggers"] === undefined)
        return false;
    if (!("actions" in value) || value["actions"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListItemResponseRules = instanceOfTemplateGalleryListItemResponseRules;
function TemplateGalleryListItemResponseRulesFromJSON(json) {
    return TemplateGalleryListItemResponseRulesFromJSONTyped(json, false);
}
exports.TemplateGalleryListItemResponseRulesFromJSON = TemplateGalleryListItemResponseRulesFromJSON;
function TemplateGalleryListItemResponseRulesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json["id"],
        triggerOperator: json["triggerOperator"],
        triggers: json["triggers"].map(TemplateGalleryListItemResponseTriggerJoined_1.TemplateGalleryListItemResponseTriggerJoinedFromJSON),
        actions: json["actions"].map(TemplateGalleryListItemResponseActionJoined_1.TemplateGalleryListItemResponseActionJoinedFromJSON),
    };
}
exports.TemplateGalleryListItemResponseRulesFromJSONTyped = TemplateGalleryListItemResponseRulesFromJSONTyped;
function TemplateGalleryListItemResponseRulesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        triggerOperator: value["triggerOperator"],
        triggers: value["triggers"].map(TemplateGalleryListItemResponseTriggerJoined_1.TemplateGalleryListItemResponseTriggerJoinedToJSON),
        actions: value["actions"].map(TemplateGalleryListItemResponseActionJoined_1.TemplateGalleryListItemResponseActionJoinedToJSON),
    };
}
exports.TemplateGalleryListItemResponseRulesToJSON = TemplateGalleryListItemResponseRulesToJSON;
